import routerOptions0 from "/builds/bunuble/bunuble/bunuble/node_modules/.pnpm/nuxt@3.17.2_@parcel+watcher@2.5.1_@types+node@22.15.17_db0@0.3.2_eslint@9.26.0_jiti@2.4_8425b33b527d0c201ab894d3252ee22f/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/builds/bunuble/bunuble/bunuble/node_modules/.pnpm/@nuxt+ui-pro@1.8.0_jwt-decode@4.0.0_magicast@0.3.5_qrcode@1.5.4_vite@6.3.5_@types+node@_0e29e3c129a2e10f08789d685704a9b2/node_modules/@nuxt/ui-pro/modules/pro/runtime/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}